var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.63 142.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110,15.48c8.14-13,13.47-11.23,11.89,4.07l-11,106.58c-1.13,11-8.34,13.53-16.11,5.67L79.16,116c-10.81-10.93-13-30.38-4.84-43.43Z",
    transform: "translate(0 0)",
    stroke: "currentColor",
    strokeWidth: 13,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.66,127.39c-8.14,13-13.46,11.22-11.88-4.08l11-106.57c1.13-11,8.35-13.53,16.11-5.68L49.46,26.83c10.82,10.94,13,30.38,4.84,43.43Z",
    transform: "translate(0 0)",
    stroke: "currentColor",
    strokeWidth: 13,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBase);
export default __webpack_public_path__ + "static/media/logo-base.55e6c3d1932e70c831152527fe5181c8.svg";
export { ForwardRef as ReactComponent };